import React, { Component } from 'react'
import { Button, Col, Container, Row } from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import OswebStore from "../stores/OswebStore";
import FiltrosOsweb from "../components/FIltrosOsweb";
import { TabelaOsweb } from "../components/TabelaOsweb";
import { OswebCadastrar } from "../components/OswebCadastrar";
import OswebService from "../../../services/OswebService";
import ModalAviso from "../../comum/components/ModalAviso";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import FooterOptions from "../../comum/components/FooterOptions";
import IconButton from "../../comum/components/IconButton";
import { makePDF } from "../../../utils/formatar";
import ExportarExcelOsweb from "../components/ExportarExcelOsweb";

@inject("store")
@DataWrapper
@observer
export class Osweb extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.loginStore = this.props.store.loginStore

        this.service = new OswebService();
        this.controller = new OswebStore(this.service);

        
    }

    can = (operacao = "C", tarefa = "OsWeb") => this.loginStore.can(tarefa, operacao)

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("OS Web");

        this.controller.listar({}); // TODO remover
    };

    oswebCadastrar = () => {
        if (this.controller.inserindo)
            return <OswebCadastrar controller={this.controller} />
    };

    aviso = () => {
        if (this.controller.listaMensagens)
            return <ModalAviso onClickFechar={() => this.controller.listaMensagens = false}>
                {this.controller.listaMensagens.map((msg, x) => <h2 key={x}>{msg}</h2>)}
            </ModalAviso>
    };

    

    modalSucesso = () => {
        if (this.controller.sucesso)
            return <ModalAviso
                onClickFechar={this.controller.fecharModalSucesso}
            >
                <h2>
                    {this.controller.sucessoMsg}
                </h2>
            </ModalAviso>
    }

    render() {
        let pdfData = this.controller.colunas;
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML');
        return (
            <div className="form-wrapper">
               
                {this.modalSucesso()}
                {this.can("I") && this.oswebCadastrar()}
                <Container className="liberacao-osweb tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        {this.can("I") &&
                            <Col xs={12} sm={12} md={12} >
                                <Button onClick={() => this.controller.inserindo = true} className="btn-com-bordas-primary">Novo Serviço</Button>
                            </Col>
                        }
                    </Row>
                    <FiltrosOsweb controller={this.controller} service={this.service} />
                    <TabelaOsweb controller={this.controller} />
                </Container>

                <Footer>
                    <FooterContent>
                        <div className="justify-content-between">
                            <div>
                                <b>{this.controller.oswebLista.length}</b> Registros no Total
                                {this.controller.estadoFiltros
                                    && <React.Fragment>
                                        - <a onClick={() => this.controller.reListar()} >Atualizar Lista</a>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </FooterContent>
                    <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.oswebLista.length === 0}
                                onClick={
                                    () => makePDF(
                                        this.controller.oswebLista,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        pdfDataTime.map(elem => elem.dataField),
                                        true,
                                        false,
                                        { qtdColFixo: "A2", nomeDoArquivo: "OSWeb.pdf" }
                                    )
                                }
                            />
                        </div>
                        <div>
                            <ExportarExcelOsweb controller={this.controller} />
                        </div>
                    </FooterOptions>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/osweb/telas/OSWeb.js